import React from 'react'
import { Card } from '@/components/Card'
import { RenderBlocks, type Block } from '@/blocks/RenderBlocks'

export type CardBlockProps = {
  title?: string | null
  variant?: 'default' | 'glass' | 'sidebar' | 'main' | null
  content?: Block[] | null
  className?: string
  blockType: 'card'
}

export const CardBlock: React.FC<CardBlockProps> = ({ title, variant, content, className }) => {
  return (
    <Card title={title || undefined} variant={variant || undefined} className={className}>
      <RenderBlocks blocks={content ?? []} />
    </Card>
  )
}
